export function farloUiParallax(selector, { speed = 0.3, zIndex = 0 } = {}) {
	if (typeof document === 'undefined') {
		return;
	}

	const elements = document.querySelectorAll(selector);
	if (!elements.length) {
		return;
	}

	// Ensure transform context
	elements.forEach((el) => {
		el.style.willChange = 'transform';
		el.style.zIndex = String(zIndex);
		el.style.position = el.style.position || 'relative';
	});

	let ticking = false;
	const onScroll = () => {
		if (!ticking) {
			requestAnimationFrame(() => {
				const scrollY = window.scrollY;
				elements.forEach((el) => {
					const translateY = scrollY * speed;
					el.style.transform = `translateY(${ translateY }px)`;
				});
				ticking = false;
			});
			ticking = true;
		}
	};

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onScroll);
	onScroll();
}
